<template>
	<div class="playbooks-table container">
		<playbooks-filters />
		<playbooks-cards v-if="hasCards" :cards="cards" />
		<!--eslint-disable vue/singleline-html-element-content-newline -->
		<div v-else class="not-found">No Playbooks Found</div>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import PlaybookFilterHandler from '../../playbooks/utils/playbookFilterHandler';
import orderBy from 'lodash/orderBy';
import { getTime, parseISO } from 'date-fns';

export default {
	computed: {
		...mapState('playbooks', ['playbooks', 'filters', 'search', 'sort', 'rules', 'upsells']),
		...mapGetters('playbooks', ['availableUpsells', 'hasRecommendations', 'shouldShowDoneForYouUpsell']),
		/**
		 * Generate the array of cards to show.
		 *
		 * We need to sort and filter the playbooks based on the current filters as well
		 * as inject the upsells if necessary.
		 *
		 * @returns {Array} The array of cards.
		 */
		cards() {
			let cards = [];
			let upsellsAdded = 0;

			const filterHandler = new PlaybookFilterHandler(this.filters, this.search, this.sort, this.rules);
			const availableUpsells = this.availableUpsells;
			const upsellCount = availableUpsells.length;

			// Filter Playbooks before sorting.
			const filteredPlaybooks = this.playbooks.filter((p) => {
				return filterHandler.shouldInclude(p);
			});

			// Sort Playbooks before injecting upsells.
			const orderedPlaybooks = orderBy(filteredPlaybooks, (playbook) => {
				return 'recent' === this.sort ? -getTime(parseISO(playbook.created_at)) : playbook.name;
			});

			orderedPlaybooks.forEach((p, i) => {
				// Add Playbook
				p.cardType = 'playbook';
				cards.push(p);

				if (!this.hasRecommendations) {
					const count = i + 1;

					// If it's the last playbook or divisible by 3 and we're not out of upsells, add.
					if ((count === filteredPlaybooks.length || 0 === count % 3) && upsellsAdded + 1 <= upsellCount) {
						let upsell = availableUpsells[upsellsAdded];

						cards.push(upsell);
						upsellsAdded++;
					}
				}
			});

			return cards;
		},
		/**
		 * Determine if we have cards to show
		 *
		 * @returns {boolean} true if we have cards to show, false otherwise.
		 */
		hasCards() {
			return 0 < this.cards.length;
		},
	},
};
</script>
